var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckupIconY(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666992,
    width: 20.0008,
    height: 20,
    rx: 10,
    fill: "#FCEDC7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 6L6.66699 6.66667M6.66699 6.66667L4.66699 12.6667C5.84868 13.5556 7.4861 13.5556 8.66779 12.6667M6.66699 6.66667L8.66703 12.6667M6.66699 6.66667L10.667 5.33333M14.667 6.66667L16.667 6M14.667 6.66667L12.667 12.6667C13.8487 13.5556 15.4861 13.5556 16.6678 12.6667M14.667 6.66667L16.667 12.6667M14.667 6.66667L10.667 5.33333M10.667 4V5.33333M10.667 16V5.33333M10.667 16H8.66699M10.667 16H12.667",
    stroke: "#CC9D24",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckupIconY);
export default __webpack_public_path__ + "static/media/checkupIconY.8c6fc03035a6b01647d4072f8ac65944.svg";
export { ForwardRef as ReactComponent };